import { getData, postData, putData, deleteData } from "../apiClient";

// get room types
export const getComplementaryWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
        });

        const result = await getData(`/complementary/?${queryParams}`, {}, {}, signal);
        return {
            success: true,
            ...result,
        };
    } catch (error) {
        console.error("Get Complementary with pagination API error:", error);
        return {
            success: false,
            ...error,
        };
    }
};

// get user data with id
export const getComplementaryDataWithId = async (id) => {
    try {
        const result = await getData(`/complementary/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Complementary data API error:", error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
};



// create user 
export const createComplementary = async ({ data }) => {
    try {
        const result = await postData(`/complementary/create-complementary/`, data);

        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Complementary add API error:", error);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// delete user
export const deleteComplementary = async ({ id }) => {
    try {
        const result = await deleteData(`/complementary/delete-complementary/${id}`);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Complementary delete API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};

// update user data
export const updateComplementary = async ({ id, data }) => {
    try {
        const result = await putData(`/complementary/update-complementary/${id}`, data);
        return {
            data: {
                success: true,
                data: result,
            },
        };
    } catch (error) {
        console.error("Complementary update API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};


export const getRoomType = async () => {
    try {
        const result = await getData(`/complementary/room-types/list`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error("Get Room Type API error:", error.status === 400 ? error.error : error.message);
        return {
            data: {
                success: false,
                error: error.status === 400 ? error.error : error.message,
                status: error.status,
            },
        };
    }
};
